import React from "react";
import { IconButton } from "@mui/material";
import CloseIcon from "assets/svgIcons/NavBar/CloseIcon";
import { useHookstate } from "@hookstate/core";
import {
  MAP_GLOBAL_STATES,
  SIDENAV_GLOBAL_STATE,
  COP_GLOBAL_STATES
} from "globalStore/globalStore";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

export const CommonHeading = ({ labelText }) => {
  const { subNavDataState } = useHookstate(SIDENAV_GLOBAL_STATE);
  const { specificCarTrackHistory } = useHookstate(MAP_GLOBAL_STATES);
  const { openSaveChangesModal, nextSubTabIndex, carPathUnSavedChanges } = useHookstate(COP_GLOBAL_STATES);
  const { actionZoneModified, refreshActionZones, mapSideNavTabState } = useHookstate(MAP_GLOBAL_STATES);
  const { t } = useTranslation();

  return (
    <HeadingWrapper>
      <Heading>{t(labelText)}</Heading>
      <IconButton
        aria-label="delete"
        size="small"
        onClick={() => {
            // tracking unsaved changes
            if (carPathUnSavedChanges.get()) {
              openSaveChangesModal.set(true);
              nextSubTabIndex.set("");
            } else if (carPathUnSavedChanges.get() || actionZoneModified.get()) {
              refreshActionZones.set(true);
              mapSideNavTabState.set("");
              nextSubTabIndex.set("");
            } else {
              subNavDataState.set("");
              specificCarTrackHistory.set(false);
            }
        }}
      >
        <CloseIcon />
      </IconButton>
    </HeadingWrapper>
  );
};

const Heading = styled.h6`
  font-size: 14px;
  font-family: "Roboto";
  text-transform: uppercase;
  line-height: 18px;
  white-space: nowrap;
  display: flex;
  align-items: center;

  img {
    margin-right: 7px;
  }
`;

const HeadingWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--section-border-color);
  padding: 0 16px 0 9px;
  min-height: 30px;
  button {
    padding: 0;
  }
  @media (max-width: 850px) {
    display: none;
  }
`;
